import React, { Component } from 'react'
import { database, auth } from 'firebase'
// import Routes from './routes'
import Navbar from './navbar'
import './HomeScreen.css'
import TrackList from './TrackListScreen'
import SearchList from './SearchScreen'
import { withRouter, BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

class HomeScreen extends Component {

    state = {
        login: false,
        trackedItems: [],
        loc: 'l'
    }

    constructor(props) {
        super(props)
        auth().onAuthStateChanged(user => this.setState({ login: user }));
    }

    componentWillMount() {
        const { uid } = auth().currentUser
        this.setState({loc:window.location.pathname})
        database().ref(`users/${uid}`)
            .once('value', e => this.setState({ trackedItems: this.getTrackedItems(e) }))
        database().ref(`users/${uid}`)
            .on('value', e => this.setState({ trackedItems: this.getTrackedItems(e) }))
    }

    getTrackedItems = e => e.val() ? Object.keys(e.val()).map(i => e.val()[i]) : []

    getTracklist = () => <TrackList items={this.state.trackedItems} />
    getSearchList = () => <SearchList items={this.state.trackedItems} />
    setActivePage = loc => this.setState({ loc })
    render() {
        const { login, loc } = this.state
        if (!login) {
            return <div> identifying user </div>
        }
        return (
            <Router>
                <div className="HomeScreen">
                    <Navbar click={this.setActivePage} active={loc}/>
                    {
                        login && <Switch>
                            <Route path='/list' component={this.getTracklist} />
                            <Route path='/search' component={this.getSearchList} />
                            <Redirect from='/' to='/list' />
                        </Switch>
                    }
                </div>
            </Router>
        )
    }
}

export default withRouter(HomeScreen);


// WEBPACK FOOTER //
// ./src/ui/screens/HomeScreen/index.js